
import { Component, Vue, Prop } from "vue-property-decorator";
import { formatAvatar } from "@/utils";
@Component({
  components: {}
})
export default class collegeItem extends Vue {
  @Prop({ required: true }) private item!: any;
  formatAvatar = formatAvatar;
  // zh_choose: any = (window as any).$getCookie("zh_choose");etCookie("zh_choose");
  // }
}
